import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_JOB_APPLY } from "../../../common/URLs";


export const fetchAppliedJobs = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_APPLY}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};


export const applyJob = async (appliedJob) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_JOB_APPLY}`; 
  // const requestData = { appliedJob}; 

  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, 
      },
      body: JSON.stringify(appliedJob),
    });

    if (!response.ok) {
      throw new Error('Failed to save job');
    }

    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
